export default __webpack_public_path__ + "static/betql-hero-left-edefdf9d265d6bae799b75943c9c7b1b.avif";